import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowDownCircle",
  "use": "ArrowDownCircle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ArrowDownCircle\"><path fill=\"#fff\" fill-opacity=\".01\" d=\"M0 0h24v24H0z\" /><path d=\"M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm3.85 6.183L12 13.992l-4.112-3.809a.245.245 0 0 0-.346 0l-.663.625a.245.245 0 0 0 0 .346l4.948 4.949a.243.243 0 0 0 .346 0l4.949-4.949a.245.245 0 0 0 0-.346l-.925-.625a.245.245 0 0 0-.346 0h-.001Z\" fill=\"#495973\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol